import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class MethodLevelsProvider {
    public data$ = new BehaviorSubject<SelectValueInterface[]>([
        {id: 1, title: 'Первый (I)'},
        {id: 2, title: 'Второй (II)'},
        {id: 3, title: 'Третий (III)'}
    ]);
}
